














import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

import { AuthenticationStatus } from "../models";

@Component
export default class AccountView extends Vue {
    @Prop() authentication!: AuthenticationStatus;
}
